<template>
  <div>
    <v-card flat>
      <v-card-text style="min-height: 50vh;">
        <v-form
          ref="form"
        >
          <div class="mb-2">
            代購訂單：{{ dgid }}
          </div>
          <div class="mb-2 caption warning--text mb-4">
            {{ isManualOrder
              ? '人工代購售後將由客服協助處理，請依訂單目前狀態填寫申請。'
              : '請提前與賣家溝通售後內容，賣家同意退款後，退款會退入您的M幣餘額。' }}
          </div>
          <div
            v-if="loading"
            class="text-center py-2"
          >
            <v-progress-circular
              indeterminate
              small
              color="primary"
            />
          </div>
          <div v-else>
            <template v-if="step===1">
              <v-radio-group
                v-model="form.disputeRequest"
                :rules="[$store.state.validationRules.required]"
                row
                class="mt-0 pt-0"
              >
                <v-radio
                  label="僅退款"
                  value="refund"
                />
                <v-radio
                  v-if="hasGsMailNos"
                  label="退貨退款"
                  value="returnRefund"
                />
              </v-radio-group>
              <div v-if="form.disputeRequest">
                <div
                  v-for="goods in productItemsFilted"
                  :key="goods.subItemIDString"
                  class="mb-2"
                >
                  <v-layout>
                    <div>
                      <v-checkbox
                        v-model="orderEntryIds"
                        :value="goods.subItemIDString"
                        :disabled="!!goods.refundId || !goods.allowApplyStatus.length || isReturnRefundBlocked(goods) || isMixedDisabled(goods)"
                      />
                    </div>
                    <img
                      :src="goods.productImgUrl[0]"
                      width="80"
                      height="80"
                      class="mr-2 rounded"
                    >
                    <div
                      class="caption"
                      style="width: 400px;"
                    >
                      <v-layout>
                        <div class="line-clamp-1">
                          {{ goods.name }}
                        </div>
                        <div
                          class="nowrap font-bold text-right"
                          style="width: 100px;"
                        >
                          ￥{{ $calc.mul(goods.price/100, orderEntryCountMap[goods.subItemIDString]) }}
                        </div>
                      </v-layout>
                      <v-layout class="mt-2">
                        <div class="grey--text">
                          <span
                            v-for="skuInfo in goods.skuInfos"
                            :key="skuInfo.name"
                            class="mr-1"
                          >
                            {{ skuInfo.value }}
                          </span>
                        </div>

                        <div>
                          共{{ goods.quantity }}件
                        </div>
                        <v-spacer />
                        <div>
                          <QuantitySelector
                            :value="orderEntryCountMap[goods.subItemIDString]"
                            :max="goods.quantity"
                            :disabled="!!goods.refundId || !goods.allowApplyStatus.length || isReturnRefundBlocked(goods) || isMixedDisabled(goods)"
                            :showMax="false"
                            @input="updateQuantity(goods.subItemIDString, $event)"
                          />
                        </div>
                      </v-layout>
                      <div class="grey--text">
                        <span
                          v-if="goods.refundId"
                          class="nowrap"
                          style="border: 1px solid currentColor; padding: 0 2px; border-radius: 4px;"
                        >
                          {{ refundStatusEnum[goods.refundStatus] }}
                        </span>
                        <span
                          v-else
                          class="nowrap"
                          style="border: 1px solid currentColor; padding: 0 2px; border-radius: 4px;"
                        >
                          {{ goods.statusStr }}
                        </span>
                      </div>
                      <div
                        v-if="!goods.refundId && goods.allowApplyStatus.length && isReturnRefundBlocked(goods)"
                        class="grey--text mt-1"
                      >
                        未發貨商品不可申請退貨退款
                      </div>
                      <div
                        v-else-if="!goods.refundId && goods.allowApplyStatus.length && isMixedDisabled(goods)"
                        class="grey--text mt-1"
                      >
                        不可與已選商品一起申請
                      </div>
                    </div>
                  </v-layout>
                </div>
                <v-layout align-center>
                  <v-checkbox
                    v-model="chkAll"
                    label="全選"
                  />
                  <v-spacer />
                  <div
                    v-if="orderEntryIds.length"
                    class="mr-3"
                  >
                    共選擇 {{ orderEntryIds.length }} 種貨品
                  </div>
                </v-layout>
                <v-btn
                  v-if="canDirectRefund"
                  :loading="submitLoading"
                  block
                  color="info"
                  class="mt-4"
                  @click="waitsellersendRefund"
                >
                  申請退款 ￥{{ $calc.add(itemAmountTotal, previewData.refundableShippingFee)/100 }}
                </v-btn>
                <v-btn
                  v-else
                  :disabled="!orderEntryIds.length"
                  block
                  color="info"
                  @click="nextStep"
                >
                  下一步
                </v-btn>
              </div>
            </template>
            <template v-else-if="step==2">
              <div>
                <v-layout>
                  <div
                    class="text-xs-right mr-2 mb-2"
                    style="width: 120px;"
                  >
                    <span class="red--text">*</span>
                    貨品情況:
                  </div>
                  <v-flex>
                    <v-radio-group
                      v-model="form.goodsStatus"
                      :rules="[$store.state.validationRules.required]"
                      class="mt-0 pt-0"
                      row
                    >
                      <v-radio
                        v-for="item in goodsStatusItems"
                        :key="item.value"
                        :value="item.value"
                        :label="item.text"
                      />
                    </v-radio-group>
                    <div style="width: 300px;">
                      <v-select
                        v-if="form.goodsStatus"
                        v-model="form.applyReasonId"
                        :items="reasons"
                        :rules="[$store.state.validationRules.required]"
                        item-text="name"
                        item-value="id"
                        class="mt-0 pt-0"
                        label="申請原因"
                      >
                        <template #label>
                          申請原因 <span class="warning--text caption">(請務必如實認真填寫)</span>
                        </template>
                      </v-select>
                    </div>
                  </v-flex>
                </v-layout>
                <div style="width:340px;">
                  <v-layout class="ma-0">
                    <div
                      class="text-xs-right mr-2"
                      style="width: 120px;"
                    >
                      <span class="red--text">*</span>
                      退款貨品金額:

                      <div class="ml-2 grey--text caption">
                        最多可退 {{ itemAmountTotal / 100 }}￥
                      </div>
                    </div>
                    <div
                      style="width: 100px"
                      class="ml-2"
                    >
                      <v-text-field
                        v-model="form.applyPayment"
                        :rules="[$store.state.validationRules.required]"
                        class="mt-0 pt-0"
                        prefix="￥"
                      />
                    </div>
                  </v-layout>

                  <v-layout>
                    <div
                      class="text-xs-right mr-2"
                      style="width: 120px;"
                    >
                      退款運費金額:

                      <div class="ml-2 grey--text caption">
                        最多可退運費 {{ previewData.shippingFee / 100 }}￥
                      </div>
                    </div>
                    <div
                      style="width: 100px"
                      class="ml-2"
                    >
                      <v-text-field
                        v-model="form.applyCarriage"
                        :disabled="!previewData.shippingFee"
                        class="mt-0 pt-0"
                        prefix="￥"
                      />
                    </div>
                  </v-layout>

                  <!-- <v-text-field
                  v-model="model.account1688"
                  :rules="[$store.state.validationRules.required]"
                  label="您的1688帳號"
                /> -->
                </div>

                <v-textarea
                  v-model="model.content"
                  :rows="3"
                  label="補充描述"
                  placeholder="補充描述"
                  auto-grow
                  solo
                  class="mt-4"
                />
                <div
                  v-if="isManualOrder"
                  class="mb-4"
                >
                  請補充售後申請所需的<span class="orange--text">客服溝通紀錄、實體照片、第三方證明等</span>佐證資料
                </div>
                <div
                  v-else
                  class="mb-4"
                >
                  請補充支持退款原因的<span class="orange--text">旺旺聊天記錄截圖、實體照片、第三方證明等</span>相關證明
                </div>
                <!-- <UploadImage
                  v-if="form.disputeRequest === 'refund' && productItemsChosed[0].allowApplyStatus.includes('refundWaitSellerSend')"
                  v-model="vouchersFiles"
                  :uploadFn="uploadFn"
                  :max="5"
                  dir="comment"
                  label="上傳憑證"
                /> -->
                <UploadImage
                  v-model="model.upyunFiles"
                  :max="5"
                  :uploadFn="refundVoucherUploadFn"
                  dir="comment"
                  label="上傳憑證"
                />

                <v-btn
                  :loading="submitLoading"
                  block
                  color="info"
                  class="mt-4"
                  @click="submit"
                >
                  <span v-if="isManualOrder">提交售後申請</span>
                  <span v-else>申請退款 ￥{{ $calc.add(form.applyPayment,form.applyCarriage) }}</span>
                </v-btn>
              </div>
            </template>
          </div>
          <!-- <v-radio-group
            v-model="model.commentType"
            :rules="[$store.state.validationRules.required]"
            class="mb-2"
          >
            <v-radio
              v-for="item in commentTypeItems"
              :key="item"
              :label="item"
              :value="item"
            />
          </v-radio-group>

          <v-textarea
            v-model="model.content"
            :rows="3"
            :rules="[$store.state.validationRules.required]"
            label="申訴內容"
            placeholder="請詳述碰到的問題"
            auto-grow
            solo
          /> -->
        </v-form>

        <!-- <div class="mb-2">
          <span class="red--text">＊</span>提供與賣家的對話截圖以及快遞面單照片
        </div>
        <UploadImage
          v-model="model.upyunFiles"
          dir="comment"
        />

        <v-btn
          :loading="submitLoading"
          block
          color="info"
          class="mt-4"
          @click="submit"
        >
          提交
        </v-btn> -->
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import UploadImage from '@/components/UploadImage'
import QuantitySelector from '@/components/QuantitySelector'
import { refundStatusEnum } from '@g/utils/dgUtils'
import {
  buildManualAliRefundPreview,
  buildDgorderAfterSaleWorkOrderParams,
  canSubmitAliRefundDirectly,
  canManualOrderReturnGoods,
  getManualAliRefundReasons,
  isManualDgorder,
} from '@g/utils/dgorderAfterSaleWorkOrder'

export default {
  components: {
    UploadImage,
    QuantitySelector,
  },
  props: {
    otherData: Object,
  },
  data () {
    return {
      refundStatusEnum,
      order: null,
      model: {
        content: '',
        commentType: '',
        account1688: '',
        upyunFiles: [],
      },
      commentTypeItems: [
        '未收到包裹或少貨',
        '包裹有破損',
        '訂單退款',
        '其他問題',
      ],

      submitLoading: false,
      loading: false,

      step: 1,
      chkAll: false,
      orderEntryIds: [],
      orderEntryCountMap: {},
      vouchersFiles: [],
      reasons: [],
      productStatus: '',
      previewData: {
        orderid: '',
        productItems: [],
        shippingFee: 0,
        refundableShippingFee: 0,
      },
      form: {
        orderId: '',
        orderEntryIds: [],
        disputeRequest: '',
        applyPayment: '',
        applyCarriage: '',
        applyReasonId: '',
        description: '',
        goodsStatus: '',
        vouchers: [
        ],
        orderEntryCountList: [
          // {
          //   'id': '1231243',
          //   'count': 1
          // }
        ]
      },
    }
  },
  computed: {
    dgid () {
      return this.otherData?.dgid || this.$route.query.dgid
    },
    goodsStatusItems () {
      return [
        {
          text: '已收到全部（或部分）貨品',
          value: 'refundBuyerReceived'
        },
        {
          text: '沒有收到貨品',
          value: 'refundWaitBuyerReceive'
        },
        {
          text: '未收到貨',
          value: 'aftersaleBuyerNotReceived'
        },
        {
          text: '已收到貨',
          value: 'aftersaleBuyerReceived'
        },
        {
          text: '未收貨（發貨前）',
          value: 'refundWaitSellerSend'
        }
      ].filter(item => {
        if (!this.productItemsChosed[0]) return false
        return this.productItemsChosed[0].allowApplyStatus.includes(item.value)
      })
    },
    productItemsChosed () {
      return this.productItemsFilted
        .filter(item => this.orderEntryIds.includes(item.subItemIDString))
    },
    itemAmountTotal () {
      return this.productItemsChosed.reduce((acc, item) => {
        let amount = item.itemAmount
        if (this.orderEntryCountMap[item.subItemIDString] < item.quantity) {
          amount = this.$calc.mul(item.price, this.orderEntryCountMap[item.subItemIDString])
        }
        return this.$calc.add(acc, amount)
      }, 0)
    },
    productItemsFilted () {
      // return this.previewData.productItems.filter(item => item.status === this.productStatus)
      const list = this.previewData.productItems.filter(goods => !goods.refundId)
      if (!list.length) {
        return this.previewData.productItems
      }
      return list
    },
    productItemsStatusList () {
      const list = []
      this.previewData.productItems.forEach(item => {
        const index = list.findIndex(i => i.value === item.status)
        if (index > -1) {
          list[index].list.push(item)
        } else {
          list.push({
            text: item.statusStr || item.status,
            value: item.status,
            list: [item]
          })
        }
      })
      return list
    },
    isRefundWaitSellerSendAllItems () {
      const firstGoods = this.productItemsChosed[0]
      return this.form.disputeRequest === 'refund' &&
          this.orderEntryIds.length === this.previewData.productItems.length &&
          !!firstGoods &&
          firstGoods.allowApplyStatus.includes('refundWaitSellerSend')
    },
    isManualOrder () {
      return isManualDgorder(this.order)
    },
    hasGsMailNos () {
      if (!this.order?.goods) return false
      if (this.isManualOrder) {
        return this.order.goods.some(goods => canManualOrderReturnGoods(this.order, goods))
      }
      const list = this.order.goods.map(goods => goods.gsMailNo).filter(v => v)
      return Array.from(new Set(list)).length > 0
    },
    canDirectRefund () {
      return canSubmitAliRefundDirectly(this.order, this.isRefundWaitSellerSendAllItems)
    },
    refundVoucherUploadFn () {
      return this.isManualOrder ? undefined : this.uploadFn
    },
  },
  watch: {
    chkAll (val) {
      if (!val) {
        this.orderEntryIds = []
        return
      }
      let candidates = this.productItemsFilted.filter(
        item => !item.refundId && item.allowApplyStatus.length
      )
      if (this.form.disputeRequest === 'returnRefund') {
        candidates = candidates.filter(item => !this.isUnshippedItem(item))
      }
      if (!candidates.length) {
        this.orderEntryIds = []
        return
      }
      let targetIsUnshipped
      if (this.orderEntryIds.length) {
        const chosen = candidates.find(item =>
          this.orderEntryIds.includes(item.subItemIDString)
        )
        targetIsUnshipped = chosen ? this.isUnshippedItem(chosen) : false
      } else {
        targetIsUnshipped = candidates.some(item => this.isUnshippedItem(item))
      }
      this.orderEntryIds = candidates
        .filter(item => this.isUnshippedItem(item) === targetIsUnshipped)
        .map(item => item.subItemIDString)
    },
    'form.disputeRequest' (val) {
      if (val === 'returnRefund') {
        this.orderEntryIds = this.orderEntryIds.filter(id => {
          const goods = this.productItemsFilted.find(item => item.subItemIDString === id)
          return goods && !this.isUnshippedItem(goods)
        })
      }
    },
    'form.goodsStatus' (val) {
      this.form.applyReasonId = ''
      this.getReasonList()
    },
    productStatus () {
      const orderEntryCountMap = {}
      this.productItemsFilted.forEach(item => {
        orderEntryCountMap[item.subItemIDString] = item.quantity
      })
      this.orderEntryCountMap = orderEntryCountMap
      this.orderEntryIds = []
    },
    orderEntryCountMap: {
      handler (val) {
        Object.keys(val).forEach(key => {
          const goods = this.previewData.productItems.find(item => item.subItemIDString === key)
          if (val[key] > goods.quantity) {
            this.$set(this.orderEntryCountMap, key, goods.quantity)
          }
        })
      },
      deep: true,
    },
    'form.applyPayment' () {
      if (this.form.applyPayment > this.itemAmountTotal / 100) {
        this.form.applyPayment = String(this.itemAmountTotal / 100)
      }
    },
    'form.applyCarriage' () {
      if (this.form.applyCarriage > this.previewData.shippingFee / 100) {
        this.form.applyCarriage = String(this.previewData.shippingFee / 100)
      }
    },
    step () {
      if (this.step === 2) {
        // this.form.applyPayment = String(this.itemAmountTotal / 100)
        // this.form.applyCarriage = String(this.previewData.shippingFee / 100)
      }
    },
  },
  created () {
    this.fetchOrder()
  },
  methods: {
    updateQuantity (subItemIDString, value) {
      this.$set(this.orderEntryCountMap, subItemIDString, value)
    },
    isUnshippedItem (goods) {
      return goods.status === 'waitsellersend'
    },
    isReturnRefundBlocked (goods) {
      return this.form.disputeRequest === 'returnRefund' && this.isUnshippedItem(goods)
    },
    isMixedDisabled (goods) {
      if (!this.orderEntryIds.length) return false
      const chosenItem = this.productItemsFilted
        .find(item => this.orderEntryIds.includes(item.subItemIDString))
      if (!chosenItem) return false
      return this.isUnshippedItem(chosenItem) !== this.isUnshippedItem(goods)
    },
    async fetchOrder () {
      try {
        this.loading = true
        const res = await this.$store.dispatch('magicbuy/dgorder/view', {
          dgid: this.dgid,
          dgPlatform: '1688',
        })
        this.order = res.data.model
        if (!this.hasGsMailNos && this.form.disputeRequest === 'returnRefund') {
          this.form.disputeRequest = 'refund'
        }

        if (this.isManualOrder) {
          this.previewData = buildManualAliRefundPreview(this.order)
        } else {
          const res2 = await this.$store.dispatch('magicbuy/dgorderRefund/goodsPreview', {
            orderId: this.order.dgOrderid,
          })
          this.previewData = res2.data.model
        }
        this.previewData.productItems?.forEach(item => {
          item.price = this.$calc.round(item.itemAmount / item.quantity, 2)
        })
        const firstStatus = this.productItemsStatusList[0]
        this.productStatus = firstStatus ? firstStatus.value : ''
      } finally {
        this.loading = false
      }
    },
    async getReasonList () {
      this.reasons = []
      if (this.isManualOrder) {
        this.reasons = getManualAliRefundReasons()
        return
      }
      const res = await this.$store.dispatch('magicbuy/dgorderRefund/reasonList', {
        orderId: this.previewData.orderid,
        orderEntryIds: this.orderEntryIds.join(','),
        goodsStatus: this.form.goodsStatus,
      })
      const str = JSON.stringify(res.data.model.reasons).replace(/拒签/g, '拒簽')
      const converter = window.OpenCC.Converter({ from: 'cn', to: 'tw' })
      this.reasons = JSON.parse(converter(str))
    },
    nextStep () {
      if (this.canDirectRefund) {
        // 发货前退款
        this.waitsellersendRefund()
      } else {
        this.step = 2
      }
    },
    async waitsellersendRefund (params) {
      // 人工单只允许提交客服工单，禁止进入平台退款接口。
      if (this.isManualOrder) return
      try {
        this.submitLoading = true
        const res = await this.$store.dispatch('magicbuy/tradeRefund/create', {
          orderId: this.previewData.orderid,
          orderEntryIds: this.orderEntryIds,
          disputeRequest: this.form.disputeRequest,
          applyPayment: String(this.itemAmountTotal, 100),
          applyCarriage: String(this.previewData.refundableShippingFee),
          applyReasonId: 20006, // 不想要了
          description: '不想要了',
          goodsStatus: 'refundWaitSellerSend',
          vouchers: [],
          ...params,
        })
        if (!res.data.error) {
          this.$confirm('已提交退款申請，請等待賣家處理', {
            confirmButtonText: '確定',
            buttonFalseText: false,
          })
          this.$router.go(-1)
          this.$emit('close')
        }
      } finally {
        this.submitLoading = false
      }
    },
    async createManualAfterSaleWorkOrder () {
      try {
        this.submitLoading = true
        const params = buildDgorderAfterSaleWorkOrderParams({
          dgid: this.dgid,
          form: this.form,
          model: this.model,
          orderEntryIds: this.orderEntryIds,
          orderEntryCountMap: this.orderEntryCountMap,
          productItemsFilted: this.productItemsFilted,
          goodsStatusItems: this.goodsStatusItems,
          reasons: this.reasons,
        })
        const res = await this.$store.dispatch('comment/createWorkOrder', params)
        if (!res.data.error) {
          this.$emit('created', { cid: res.data.model.cid })
        }
      } finally {
        this.submitLoading = false
      }
    },
    async uploadFn (file) {
      if (this.isManualOrder) {
        return this.$store.dispatch('upyun/uploadImg', {
          file,
          policyParams: { dir: 'comment' },
        })
      }
      const formData = new FormData()
      formData.append('orderId', this.previewData.orderid)
      formData.append('imageFile', file, file.name)
      return this.$store.dispatch('magicbuy/tradeRefund/uploadRefundVoucher', formData)
    },
    async submit () {
      if (!this.$refs.form.validate()) {
        return
      }
      if (!this.model.content.length) {
        this.$snackbar('請補充描述')
        return
      }
      if (this.submitLoading) return
      if (!this.model.upyunFiles.length) {
        this.$snackbar('請上傳憑證')
        return
      }
      let orderEntryCountList = []
      if (this.form.disputeRequest === 'returnRefund' && this.form.goodsStatus === 'refundBuyerReceived') {
        orderEntryCountList = this.orderEntryIds.map(id => ({
          id,
          count: this.orderEntryCountMap[id]
        }))
      }
      if (this.isManualOrder) {
        return this.createManualAfterSaleWorkOrder()
      }
      return this.waitsellersendRefund({
        applyPayment: this.$calc.mul(this.form.applyPayment, 100),
        applyCarriage: this.$calc.mul(this.form.applyCarriage, 100),
        applyReasonId: this.form.applyReasonId,
        description: this.model.content,
        goodsStatus: this.form.goodsStatus,
        vouchers: this.model.upyunFiles.map(item => item.url),
        // vouchers: ['https://cbu01.alicdn.com/img/ibank/O1CN017qAWg21Bs32eJgMVk_!!0-0-cib.jpg'],
        orderEntryCountList,
      })
      // try {
      //   this.submitLoading = true

      //   let content = `代購售後 ${this.dgid} `
      //   content += this.form.disputeRequest === 'refund' ? '僅退款' : '退貨退款'
      //   this.orderEntryIds.map(id => ({
      //     id,
      //     count: this.orderEntryCountMap[id]
      //   }))
      //   this.orderEntryIds.forEach(id => {
      //     const count = this.orderEntryCountMap[id]
      //     const goods = this.productItemsFilted.find(item => item.subItemIDString === id)
      //     content += `\n${goods.name}\n`
      //     if (goods.skuInfos?.length) {
      //       goods.skuInfos.forEach(skuInfo => {
      //         content += `${skuInfo.value} `
      //       })
      //     }
      //     content += `x ${count}`
      //   })

      //   content += `\n貨品情況: ${this.goodsStatusItems.find(item => item.value === this.form.goodsStatus).text}`
      //   content += `\n申請原因: ${this.reasons.find(item => item.id === this.form.applyReasonId).name}`
      //   content += `\n退款貨品金額: ￥${this.form.applyPayment}`
      //   content += `\n退款運費金額: ￥${this.form.applyCarriage}`
      //   content += `\n${this.model.content}`
      //   const params = {
      //     ignoreLimit: '1',
      //     tag: 'dgorder',
      //     site: 'MG',
      //     title: '代購售後服務',
      //     upyunFiles: this.model.upyunFiles,
      //     // content: `代購售後 ${this.dgid} ${this.model.commentType}，1688帳號 ${this.model.account1688}\n${this.model.content}`,
      //     content,
      //   }

      //   // console.log(params)

      //   const res = await this.$store.dispatch('comment/createWorkOrder', params)
      //   if (!res.data.error) {
      //     this.$snackbar('已提交售後服務', { color: 'success' })
      //     // this.$router.go(-1)
      //     this.$emit('created', { cid: res.data.model.cid })
      //   }
      // } finally {
      //   this.submitLoading = false
      // }
    },
  }
}
</script>
